import { useQuery } from '@tanstack/react-query';

import { api } from '../api/client';

/** Poll ``/status`` every 5 s. Header bar reads this for the
 *  scheduler-running indicator and the summary counts feed it too. */
export function useStatus() {
  return useQuery({
    queryKey: ['status'],
    queryFn: api.status,
    refetchInterval: 5000,
    staleTime: 2000,
  });
}
